<div mat-dialog-title class="flex flex-row">
    Forma de pagamento
    <div class="flex-fill"></div>
    <div class="btn-options">
        <button color="primary" (click)="dialogRef.close()" mat-icon-button matTooltip="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
<div mat-dialog-content>
    <div class="flex flex-column align-center">
        <mat-icon class="alert-icon" color="primary">help</mat-icon>
        <h1>Qual a forma de pagamento?</h1>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button (click)="close(3)" color="accent">Boleto bancário</button>
    <button mat-raised-button (click)="close(2)" color="primary" *ngIf="!data.isAluno">Cartão de débito</button>
    <button mat-raised-button (click)="close(1)" color="primary">Cartão de crédito</button>
    <button mat-raised-button (click)="close(4)" color="primary" *ngIf="!data.isAluno">Pix (TEF)</button>
</div>
